module.exports = __webpack_public_path__ + "assets/img/thumb-LJ-Hooker-Video.dd6d1408.jpg";